import { index } from 'd3'
import { makeGroupColumn } from './c01-group-column.js'
import { getEntityName } from '../utils/get-entity-name.js'
import { makeConvertedAmountsColumns } from './c10-converted-amounts-columns.js'
import { makeLocalAmountColumns } from './c20-local-amount.js'
import { makeWhyIntercoColumn } from './c30-why-interco.js'
import { makeSourceColumns } from './c40-source-columns.js'

export function makeColDefs (context) {
  console.log('makeColDefs', context)

  const entitiesMap = index(context.browserAppAccount.data.entities, e => e.id)
  const groupingMethod = context.menuOptions.optionGrouping.selectedOption().value

  const columnDefs = []

  columnDefs.push(makeGroupColumn(context, entitiesMap, groupingMethod))

  columnDefs.push({
    headerName: 'Recording Entity',
    valueGetter: function (cellParams) {
      if (cellParams.data.type === 'break') return null

      return getEntityName(cellParams.data.transaction?.chart_of_account_accounting_organisation_id, entitiesMap)
    },
    pinned: 'left'
  })

  columnDefs.push({
    headerName: 'Represented Entity',
    valueGetter: function (cellParams) {
      if (cellParams.data.type === 'break') return null

      return getEntityName(cellParams.data.transaction?.intercompany_entity_id, entitiesMap)
    },
    pinned: 'left'
  })

  columnDefs.push({
    headerName: 'Account',
    valueGetter: function (cellParams) {
      if (['break', 'dateGroup', 'entityPair'].includes(cellParams.data.type)) return null

      const statement = cellParams.data.transaction?.chart_of_account_statement
      return `[${statement}] ${cellParams.data.transaction?.chart_of_account_name}`
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return null

      const statement = cellParams.data.transaction?.chart_of_account_statement
      return `<span class="tag ${statement === 'bs' ? 'is-light' : ''} ${statement === 'bs' ? 'is-info' : 'is-primary'}">${statement}</span> ${cellParams.data.transaction?.chart_of_account_name}`
    },
    pinned: 'left'
  })

  const convertedAmountsColumns = makeConvertedAmountsColumns(context)
  columnDefs.push(...convertedAmountsColumns)

  columnDefs.push(makeWhyIntercoColumn(context))

  const localAmountColumns = makeLocalAmountColumns(context)
  columnDefs.push(...localAmountColumns)

  columnDefs.push(...makeSourceColumns(context, entitiesMap))

  return columnDefs
}
